import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { Row, Table } from 'reactstrap';

function StatsTables({ data: assetData }) {
  const [evalmetrics, setEvalmetrics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [seriesConfig, setSeriesConfig] = useState({});
  const strategyLabel = seriesConfig?.index1 || 'MQE Strategy';
  const benchmarkLabel =
    evalmetrics.find((item) => item?.hfrititle)?.hfrititle || 'HFRI 500';

  const assetId = assetData?.id;

  const fetchData = useCallback(async (type) => {
    try {
      const url =
        type === 'assets'
          ? `${process.env.REACT_APP_BASE_URL}/assets/${assetId}/evalmetrics?skip=0&limit=10`
          : `${process.env.REACT_APP_BASE_URL}/portfolios/${assetId}/evalmetrics?skip=0&limit=10`;
      const response = await axios.get(url);
      if (response.status === 200) {
        setEvalmetrics(response?.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  }, [assetId]);

  const fetchConfigs = useCallback(async (type) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/display-configs/${assetId}?scope=${type}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
          },
        }
      );
      if (response.status === 200) {
        setSeriesConfig(response.data);
      }
    } catch (error) {
      console.error('Error fetching configs:', error);
      setSeriesConfig({});
    }
  }, [assetId]);

  const fetchPortFolioData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/portfolios/?skip=0&limit=1000`
      );
      if (response.status === 200) {
        const isPortfolio =
          response?.data?.data?.length &&
          response.data.data.some((d) => d.id === assetId);
        const type = isPortfolio ? 'portfolio' : 'assets';
        fetchData(type);
        fetchConfigs(isPortfolio ? 'portfolio' : 'asset');
      }
    } catch (error) {
      console.error('Error fetching portfolio data:', error);
    }
  }, [assetId, fetchData, fetchConfigs]);

  useEffect(() => {
    if (assetId) {
      fetchPortFolioData();
    }
  }, [assetId, fetchPortFolioData]);

  return (
    <Row className="p-3">
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 400,
            width: '100%',
          }}
        >
          <ClipLoader size={45} color="#005687" />
        </div>
      ) : (
        <Table striped bordered responsive className="stats-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>{strategyLabel}</th>
              <th>{benchmarkLabel}</th>
            </tr>
          </thead>
          <tbody>
            {evalmetrics?.length ? (
              <>
                {evalmetrics.map((item, index) => (
                  <tr key={item?.metric || index}>
                    <td>{item?.metric}</td>
                    <td>{item?.mqe}</td>
                    <td>{item?.hfri}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td style={{ textAlign: 'center' }} colSpan="3">
                  Coming Soon
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </Row>
  );
}

export default StatsTables;
